import LetterTile from './LetterTile';
import './GuessRow.css';

function GuessRow({ guess, evaluation, isRevealed, isCurrent, rowIndex }) {
  const letters = guess.padEnd(6, ' ').split('');

  return (
    <div className={`guess-row ${isCurrent ? 'current' : ''}`} role="row">
      {letters.map((letter, index) => (
        <LetterTile
          key={index}
          letter={letter.trim()}
          evaluation={evaluation ? evaluation[index] : null}
          isRevealed={isRevealed}
          delay={index * 300}
          position={index}
        />
      ))}
    </div>
  );
}

export default GuessRow;